import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import useUIBp from "../../../Hooks/useUIBoilerplate";
import { Grid2, TextField } from "@mui/material";
import { defaultTime } from "./genericIDs";
import { UIactions } from "../../../store/slices/UI";
import { useEffect, useMemo } from "react";

const TimePckr = ({
  id = defaultTime,
  size = 12,
  componentSize = "small",
  clearOnUnmount,
  minTime,
  maxTime,
  UIText,
}) => {
  const { dispatch, UI, settings } = useUIBp();
  const field = useMemo(() => UI[id], [UI, id]);
  const locale = settings.locale;
  const { label } = UIText[locale] ?? UIText.universal;

  // useEffect(() => {
  //   if (!field) {
  //     dispatch(UIactions.setField({ id, value: dayjs() }));
  //   }
  // }, [dispatch, field, id]);

  useEffect(() => {
    return () => {
      if (clearOnUnmount) {
        dispatch(UIactions.clear(id));
      }
    };
  }, [dispatch, clearOnUnmount, id]);

  const handleChange = (value, err) => {
    dispatch(UIactions.setField({ id, value }));
  };

  const handleError = (err) => {
    if (!!err) {
      dispatch(UIactions.setFieldError({ id, value: err }));
    }
  };

  return (
    <Grid2 container {...{ size }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          {...{
            ampm: false,
            size: componentSize,
            onChange: handleChange,
            value: !!field ? dayjs(field.value) : dayjs(),
            maxTime,
            minTime,
            sx: { width: "100%" },
            formatDensity: "dense",
            slots: { textField: TextField },
            onError: handleError,
            slotProps: {
              textField: {
                label,
                size: componentSize,
                sx: {
                  width: "100%",
                  "& .MuiInputBase-input": {
                    textAlign: "center", // Center the text
                  },
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </Grid2>
  );
};

export default TimePckr;
